export default {
  'usage.title': 'Dashboard de Uso',
  'usage.subtitle': 'Consumo filtrable del plan, operaciones, documentos, IA y organización',
  'usage.refresh': 'Actualizar',
  'usage.filters.title': 'Filtros',
  'usage.filters.environment': 'Ambiente',
  'usage.filters.environment.all': 'Todos los ambientes',
  'usage.filters.dates': 'Rango de fechas',
  'usage.filters.process': 'Proceso',
  'usage.filters.agent': 'Agente IA',
  'usage.filters.user': 'Usuario',
  'usage.filters.userHint':
    'Usuario: el significado depende de la tarjeta (solicitante, asignado, owner o creador).',
  'usage.filters.agentRpaHint': 'Este filtro solo aplica a agentes IA, no a RPA.',
  'usage.filters.invalidRange':
    'El rango de fechas no es válido (máx. 366 días; dateTo > dateFrom).',
  'usage.filters.apply': 'Aplicar',
  'usage.filters.reset': 'Restablecer',
  'usage.filters.clearAll': 'Limpiar todo',

  'usage.scope.company': 'Compañía',
  'usage.scope.environment': 'Ambiente',
  'usage.scope.process': 'Proceso',
  'usage.scope.agent': 'Agente',
  'usage.scope.user': 'Usuario',

  'usage.context.title': 'Estás viendo el consumo de:',
  'usage.context.allCompany': 'Toda la compañía',

  'usage.metric.applied': 'Refleja tus filtros',
  'usage.metric.notApplied': 'Filtro no aplicado: {filters}',
  'usage.metric.filter.dateFrom': 'Desde',
  'usage.metric.filter.dateTo': 'Hasta',
  'usage.metric.filter.environmentIds': 'Ambiente',
  'usage.metric.filter.processIds': 'Proceso',
  'usage.metric.filter.agentIds': 'Agente IA',
  'usage.metric.filter.userIds': 'Usuario',
  // Singular keys kept for older envelopes during rollout
  'usage.metric.filter.environmentId': 'Ambiente',
  'usage.metric.filter.processId': 'Proceso',
  'usage.metric.filter.agentId': 'Agente IA',
  'usage.metric.filter.userId': 'Usuario',

  'usage.plan.title': 'Tu plan',
  'usage.plan.requests': 'Solicitudes',
  'usage.plan.documents': 'Documentos generados',
  'usage.plan.storage': 'Almacenamiento',
  'usage.plan.emails': 'Emails',
  'usage.plan.entities': 'Entidades dinámicas',
  'usage.plan.ai': 'Consumo IA',
  'usage.plan.aiCredits': 'Créditos disponibles: {value}',
  'usage.plan.of': 'de {total}',
  'usage.plan.unlimited': 'Sin límite',
  'usage.plan.pending': 'Se calcula al cargar el detalle',
  'usage.plan.warn': 'Cerca del límite',
  'usage.plan.over': 'Sobre el plan',

  'usage.section.planUsage': 'Plan y consumo',
  'usage.section.planUsage.subtitle':
    'Uso del período frente a los límites contratados, por tipo de consumo',
  'usage.section.planUsage.subtitle.filtered':
    'Consumo de tu selección (proceso / agente / usuario) frente a los límites totales del plan',
  'usage.section.consumption': 'Uso por tipo de consumo',
  'usage.section.requests': 'Solicitudes',
  'usage.section.requests.subtitle': 'ProcessInstances del período',
  'usage.section.operations': 'Operaciones',
  'usage.section.bulk': 'Solicitudes masivas',
  'usage.section.userTasks': 'Tareas de usuario',
  'usage.section.documents': 'Documentos y almacenamiento',
  'usage.section.documents.subtitle': 'Separar stock de plan vs documentos filtrados',
  'usage.section.emails': 'Emails',
  'usage.section.ai': 'Consumo de IA',
  'usage.section.ai.subtitle': 'Tokens, precio, ledger y créditos (no confundir métricas)',
  'usage.section.aiAgents': 'Agentes IA',
  'usage.section.rpa': 'Agentes RPA',
  'usage.section.rpa.subtitle': 'Dominio separado — el filtro de agente IA no aplica',
  'usage.section.organization': 'Organización',
  'usage.section.organization.subtitle': 'Inventario / stock de la compañía',
  'usage.section.aux': 'Secciones auxiliares',
  'usage.section.loadMore': 'Cargar sección',
  'usage.section.retry': 'Reintentar',

  'usage.status.execution': 'En ejecución',
  'usage.status.approved': 'Aprobada',
  'usage.status.rejected': 'Rechazada',
  'usage.status.canceled': 'Cancelada',
  'usage.status.voided': 'Anulada',
  'usage.status.error': 'Error',
  'usage.status.unknown': '{status}',

  'usage.requests.total': 'Total',
  'usage.requests.byStatus': 'Por estado',
  'usage.requests.byProcess': 'Top por proceso',

  'usage.bulk.totalTasks': 'Tareas bulk',
  'usage.bulk.totalRequested': 'Instancias solicitadas',
  'usage.bulk.items': 'Ítems',
  'usage.bulk.successful': 'Exitosos',
  'usage.bulk.failed': 'Fallidos',

  'usage.tasks.total': 'Total tareas',
  'usage.tasks.finished': 'Finalizadas en período',
  'usage.tasks.overdue': 'Vencidas abiertas',
  'usage.tasks.overdueHint': 'Stock vencido abierto — las fechas del filtro no aplican',
  'usage.tasks.byType': 'Por tipo',

  'usage.docs.total': 'Documentos',
  'usage.docs.bySource': 'Por origen',
  'usage.storage.planUsed': 'Uso plan (snapshot)',
  'usage.storage.planLimit': 'Límite plan',
  'usage.storage.planPercent': '% del plan',
  'usage.storage.docsStock': 'Stock documentos (filtrado)',
  'usage.storage.docsAdded': 'Alta en período',
  'usage.storage.planHint': 'El % del plan usa solo planUsed / planLimit, no el stock filtrado.',

  'usage.emails.planConsumption': 'Consumo plan',
  'usage.emails.planLimit': 'Límite plan',
  'usage.emails.traced': 'Intentos trazados',
  'usage.emails.succeeded': 'Exitosos',
  'usage.emails.failed': 'Fallidos',
  'usage.emails.hint': 'El consumo de plan y las trazas no tienen por qué coincidir.',

  'usage.ai.finalPrice': 'FinalPrice',
  'usage.ai.planAllocation': 'Asignación plan',
  'usage.ai.creditsAvailable': 'Créditos disponibles (período)',
  'usage.ai.creditsAssigned': 'Créditos asignados (stock)',
  'usage.ai.inputTokens': 'Tokens input',
  'usage.ai.inputCache': 'Tokens cache',
  'usage.ai.outputTokens': 'Tokens output',
  'usage.ai.totalTokens': 'Tokens totales',
  'usage.ai.byModel': 'Por modelo',
  'usage.ai.ledger': 'Ledger de billing',
  'usage.ai.ledgerConsumed': 'Consumido ledger',
  'usage.ai.ledgerEntries': 'Entradas ledger',
  'usage.ai.ledgerHint': 'FinalPrice ≠ ledger ≠ créditos. Son métricas distintas.',
  'usage.ai.cta': 'Ver detalle de consumos',
  'usage.ai.creditApplied': 'Credit Applied',

  'usage.agents.total': 'Agentes',
  'usage.agents.active': 'Activos',
  'usage.agents.schedules': 'Schedules',
  'usage.agents.executions': 'Ejecuciones (jobs)',
  'usage.agents.succeeded': 'Jobs OK',
  'usage.agents.failed': 'Jobs fallidos',
  'usage.agents.threads': 'Threads creados',
  'usage.agents.hint': 'Jobs ≠ threads ≠ llamadas a modelo ≠ entradas de ledger.',

  'usage.rpa.agents': 'Agentes RPA',
  'usage.rpa.flows': 'Flows',
  'usage.rpa.instances': 'Instancias',
  'usage.rpa.active': 'Activos',

  'usage.org.users': 'Usuarios',
  'usage.org.entities': 'Entidades dinámicas',
  'usage.org.lists': 'Listas personalizadas',
  'usage.org.positions': 'Cargos',
  'usage.org.areas': 'Áreas',
  'usage.org.groups': 'Grupos de usuarios',
  'usage.org.active': 'Activos',
  'usage.org.total': 'Total',
  'usage.org.planLimit': 'Límite plan',

  'usage.empty': 'Sin datos para los filtros seleccionados',
  'usage.loading': 'Cargando…',
  'usage.error': 'No se pudo cargar esta sección',
};
